import React from 'react';
import { Video } from 'lucide-react';

const VideoCanvas = ({ videoRef, canvasRef, onLoadedMetadata }) => {
  return (
    <div className="relative mx-auto w-full max-w-2xl">
      {/* Video Container */}
      <div
        className="
          relative
          aspect-[4/5]
          bg-primary-black 
          rounded-2xl 
          overflow-hidden 
          border-2 border-accent-green/30
          shadow-2xl shadow-accent-green/5
          max-h-[500px]
          m-auto
        "
      >
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          onLoadedMetadata={onLoadedMetadata}
          className="absolute inset-0 w-full h-full object-cover scale-x-[-1]"
          style={{ maxHeight: '500px' }}
        />
        <canvas
          ref={canvasRef}
          className="absolute inset-0 w-full h-full object-cover scale-x-[-1] pointer-events-none"
        />
        
        {/* Scanning Frame - Subtle corners */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-3 left-3 w-6 h-6 border-t-3 border-l-3 border-accent-green rounded-tl-lg" />
          <div className="absolute top-3 right-3 w-6 h-6 border-t-3 border-r-3 border-accent-green rounded-tr-lg" />
          <div className="absolute bottom-3 left-3 w-6 h-6 border-b-3 border-l-3 border-accent-green rounded-bl-lg" />
          <div className="absolute bottom-3 right-3 w-6 h-6 border-b-3 border-r-3 border-accent-green rounded-br-lg" />
        </div>
        
        {/* Video Icon Overlay (optional, for loading state) */}
        <div className="absolute inset-0 flex items-center justify-center bg-primary-black/80 pointer-events-none opacity-0 transition-opacity">
          <Video className="text-accent-green/30" size={48} />
        </div>
      </div>
    </div>
  );
};

export default VideoCanvas;